const features = [
  { icon: 'ri-shield-check-line', title: '高清不缓冲', desc: '全站采用高速CDN分发，夫妻必看影视高清在线全集播放流畅稳定，告别卡顿等待，让每一帧画面都清晰动人。' },
  { icon: 'ri-heart-2-line', title: '精选片单', desc: '专业编辑团队从海量影片中精心筛选适合夫妻情侣共赏的浪漫电影推荐，每周更新，品质有保障。' },
  { icon: 'ri-device-line', title: '全端适配', desc: '支持电脑、平板、手机多终端无缝切换，躺在沙发上还是靠在床头，随时随地享受二人世界电影时光。' },
  { icon: 'ri-lock-2-line', title: '安全私密', desc: '无需注册登录即可免费观看，观影记录完全私密，让夫妻影院的温馨体验不被打扰。' },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
        <div className="text-center mb-12">
          <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
            为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            平台优势
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-7 hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 mb-5 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2.5">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}